module Core {
    export class Scopes {
        static TIMECHEF: string = "timechef"; 
        static TIMECHEFPRO: string = "timechefpro"; 
    }
}